import { Alert, AlertDescription } from "@patient-watch/ui/alert";
import { AnimatePresence, motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";
import { useEffect, useState } from "react";
import { colors } from "@patient-watch/icons";
import { useAuth } from "../../../utils/auth";
import { useProfileCopy } from "@/features/i18n/profileCopy";

interface NotificationsDisabledAlertProps {
    isVisible?: boolean;
}

const NotificationsDisabledAlert = ({ isVisible = true }: NotificationsDisabledAlertProps) => {
    const [show, setShow] = useState(isVisible);
    const auth = useAuth();
    const copy = useProfileCopy();

    useEffect(() => {
        setShow(isVisible);
    }, [isVisible]);

    const alertMessage = auth.roles.isClinician
        ? copy.notificationsDisabledWarningClinician
        : copy.notificationsDisabledWarningPatient;
    return (
        <AnimatePresence mode="sync">
            {show && (
                <motion.div
                    layout
                    initial={{ opacity: 0, height: 0, scale: 0.95 }}
                    animate={{ opacity: 1, height: "auto", scale: 1 }}
                    exit={{ opacity: 0, height: 0, scale: 0.95 }}
                    transition={{
                        duration: 0.2,
                        ease: "easeOut",
                    }}
                >
                    <Alert variant="warning" className="bg-amber-50 mb-4 border-amber-200 text-amber-800">
                        <AlertTriangle size={20} stroke={colors["amber-600"]} />
                        <AlertDescription>{alertMessage}</AlertDescription>
                    </Alert>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default NotificationsDisabledAlert;
